import axios, { AxiosResponse } from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

export const baseURL = `${baseAPI}/advertiser-brand`

/**
 * Listar marcas (agregado por marca). Com `count: false` a API devolve o
 * array puro, sem o envelope de paginação.
 */
export function listAdvertiserBrandsService(
  params: ListAdvertiserBrandsRequest & { count: false }
): Promise<AxiosResponse<AdvertiserBrand[]>>
export function listAdvertiserBrandsService(
  params?: ListAdvertiserBrandsRequest
): Promise<AxiosResponse<ListAdvertiserBrandsResponse>>
export function listAdvertiserBrandsService(
  params?: ListAdvertiserBrandsRequest
) {
  return axios.get(baseURL, { params })
}

/**
 * Criar marca com produtos iniciais
 */
export const createAdvertiserBrandService = (
  body: CreateAdvertiserBrandRequest
) => axios.post<CreateAdvertiserBrandResponse>(baseURL, body)

/**
 * Renomear marca
 */
export const renameAdvertiserBrandService = (
  body: RenameAdvertiserBrandRequest
) => axios.patch<RenameAdvertiserBrandResponse>(baseURL, body)

/**
 * Excluir marca (e todos os vínculos)
 */
export const deleteAdvertiserBrandService = (brand: string) =>
  axios.delete(baseURL, { params: { brand } })

/**
 * Listar vínculos produto→marca
 */
export const listAdvertiserBrandProductsService = (
  params?: ListAdvertiserBrandProductsRequest
) =>
  axios.get<ListAdvertiserBrandProductsResponse>(`${baseURL}/products`, {
    params,
    // `brand` aceita lista: chave repetida em vez de `brand[]`
    paramsSerializer: { indexes: null }
  })

/**
 * Adicionar produtos a uma marca existente
 */
export const addAdvertiserBrandProductsService = (
  body: AddAdvertiserBrandProductsRequest
) => axios.post<AddAdvertiserBrandProductsResponse>(`${baseURL}/products`, body)

/**
 * Vincular/mover produtos para outra marca — único verbo que reatribui
 * um produto já vinculado a outra marca
 */
export const moveAdvertiserBrandProductsService = (
  body: MoveAdvertiserBrandProductsRequest
) =>
  axios.patch<MoveAdvertiserBrandProductsResponse>(`${baseURL}/products`, body)

/**
 * Remover vínculos de uma marca
 */
export const deleteAdvertiserBrandProductsService = (
  body: DeleteAdvertiserBrandProductsRequest
) =>
  axios.delete<DeleteAdvertiserBrandProductsResponse>(`${baseURL}/products`, {
    data: body
  })

// sem Content-Type manual: o axios define multipart com o boundary certo
const postImport = <T>(file: File, params?: { dry_run: true }) => {
  const formData = new FormData()
  formData.append('file', file)

  return axios.post<T>(`${baseURL}/import`, formData, params ? { params } : {})
}

/**
 * Dry-run do import de planilha: valida e devolve o preview do review.
 */
export const previewAdvertiserBrandImportService = (file: File) =>
  postImport<AdvertiserBrandImportPreviewResponse>(file, { dry_run: true })

/**
 * Import de planilha: grava os vínculos do mesmo arquivo já validado.
 */
export const importAdvertiserBrandService = (file: File) =>
  postImport<AdvertiserBrandImportResponse>(file)

/**
 * Sugestões em lote entre as marcas do anunciante (nunca gravam sozinhas).
 * O BFF resolve as marcas e os publishers a partir da sessão; com `sku`, a
 * lista inclui os produtos sem EAN.
 */
export const listAdvertiserBrandSuggestionsService = () =>
  axios.get<AdvertiserBrandSuggestion[]>(`${baseURL}/suggestions`, {
    params: { identifier_types: 'ean,sku' }
  })

/**
 * Busca agregada nos publishers vinculados: item com EAN uma vez só, item sem
 * EAN um por publisher e SKU
 */
export const advertiserBrandCatalogSearchService = (
  body: AdvertiserBrandCatalogSearchRequest
) =>
  axios.post<AdvertiserBrandCatalogSearchItem[]>(
    `${baseURL}/catalog-search`,
    body
  )
